export type CardData = {
  label: string,
  value: string
}

export enum EntityAction {
  'linkToOwner' = 'linkToOwner',
  'create' = 'create',
  'tooMany' = 'tooMany',
  'fusion' = 'fusion',
  'success' = 'success',
}
